import { render, staticRenderFns } from "./RefundList2_Reject.vue?vue&type=template&id=a5185a12&scoped=true&"
import script from "./RefundList2_Reject.vue?vue&type=script&lang=js&"
export * from "./RefundList2_Reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5185a12",
  null
  
)

export default component.exports